export const STATUS_COLORS: Record<string, { bg: string; color: string }> = {
    onboarded: { bg: '#22c55e', color: '#ffffff' },
    passed: { bg: '#ffeeee', color: '#df666a' },
    rejected: { bg: '#ffeeee', color: '#df666a' },
    'deal ongoing': { bg: '#e1ffe1', color: '#49a71b' },
    'deal running': { bg: '#e1ffe1', color: '#49a71b' },
    new: { bg: '#dbeafe', color: '#2563eb' },
    qualified: { bg: '#dbeafe', color: '#2563eb' },
};

export type SortKey =
    | 'orgName'
    | 'leadStatus'
    | 'relationshipStatus'
    | 'revenue'
    | 'ebitdaPct'
    | 'existingDebt'
    | 'equityRaised'
    | 'investors'
    | 'sector'
    | 'subSector'
    | 'bureauScore'
    | 'state'
    | 'similarityScore';
export type SortDir = 'asc' | 'desc';

export const OVERVIEW_HOVER_CARD = {
    TITLE: 'Company Overview',
    LOADING: 'Loading overview…',
    EMPTY: 'No overview available.',
} as const;

export const COLUMNS = [
    { key: 'orgName', label: 'Entity', sortable: true, width: '12.6875rem', numeric: false },
    { key: 'leadStatus', label: 'Lead Status', sortable: true, width: '7.5rem', numeric: false },
    { key: 'relationshipStatus', label: 'Relationship Status', sortable: true, width: '9.625rem', numeric: false },
    { key: 'revenue', label: 'Revenue', sortable: true, width: '8.75rem', numeric: true },
    { key: 'ebitdaPct', label: 'EBITDA %', sortable: true, width: '5.625rem', numeric: true },
    { key: 'existingDebt', label: 'Existing Debt', sortable: true, width: '7.5625rem', numeric: true },
    { key: 'equityRaised', label: 'Equity Raised', sortable: true, width: '9.0625rem', numeric: true },
    { key: 'investors', label: 'Top Investors', sortable: true, width: '9.8125rem', numeric: false },
    { key: 'bureauScore', label: 'Bureau Score', sortable: true, width: '7.5rem', numeric: true },
    { key: 'state', label: 'State', sortable: true, width: '10rem', numeric: false },
    { key: 'sector', label: 'Sector', sortable: true, width: '8.75rem', numeric: false },
    { key: 'subSector', label: 'Sub-Sector', sortable: true, width: '8.75rem', numeric: false },
    { key: 'similarityScore', label: 'Similarity Score', sortable: true, width: '7rem', numeric: true },
] as const;
